module.exports = __webpack_public_path__ + "fonts/Aqum-2-Classic-2.03df3816.otf";